// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__oMYIo","status":"About_status__XZb0p","tekh_skills":"About_tekh_skills__fcgPX","soft_skills":"About_soft_skills__Pb-Bo","history":"About_history__+wnGV"};